import { render } from "./sellsummary.vue?vue&type=template&id=9954eec8"
import script from "./sellsummary.vue?vue&type=script&lang=js"
export * from "./sellsummary.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jx/project/wld/nongxin-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__